import type * as Types from '../../types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import document from './menuItemUserPopQuery.gql';
import type * as ApolloReactCommon from '~/lazy_apollo/client';
import * as ApolloReactHooks from '~/lazy_apollo/client';
const defaultOptions = {} as const;
export type MenuItemUserPopQuery_menuItem_MenuItem_userPop_Pop = {
  __typename: 'Pop',
  id: number,
  popType: string
};

export type MenuItemUserPopQuery_menuItem_MenuItem = {
  __typename: 'MenuItem',
  id: number,
  userPop?: MenuItemUserPopQuery_menuItem_MenuItem_userPop_Pop | null
};

export type MenuItemUserPopQuery_Query = {
  __typename?: 'Query',
  menuItem?: MenuItemUserPopQuery_menuItem_MenuItem | null
};


export type MenuItemUserPopQueryVariables = Types.Exact<{
  menuItemId: Types.Scalars['Int']['input'];
}>;


export type MenuItemUserPopQuery = MenuItemUserPopQuery_Query;


export const MenuItemUserPopDocument = /*#__PURE__*/ document as unknown as DocumentNode<MenuItemUserPopQuery, MenuItemUserPopQueryVariables>;


/**
 * __useMenuItemUserPopQuery__
 *
 * To run a query within a React component, call `useMenuItemUserPopQuery` and pass it any options that fit your needs.
 * When your component renders, `useMenuItemUserPopQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMenuItemUserPopQuery({
 *   variables: {
 *      menuItemId: // value for 'menuItemId'
 *   },
 * });
 */
export function useMenuItemUserPopQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MenuItemUserPopQuery, MenuItemUserPopQueryVariables> & ({ variables: MenuItemUserPopQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MenuItemUserPopQuery, MenuItemUserPopQueryVariables>(MenuItemUserPopDocument, options);
      }
export function useMenuItemUserPopLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MenuItemUserPopQuery, MenuItemUserPopQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MenuItemUserPopQuery, MenuItemUserPopQueryVariables>(MenuItemUserPopDocument, options);
        }
// @ts-ignore
export function useMenuItemUserPopSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MenuItemUserPopQuery, MenuItemUserPopQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MenuItemUserPopQuery, MenuItemUserPopQueryVariables>;
export function useMenuItemUserPopSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MenuItemUserPopQuery, MenuItemUserPopQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MenuItemUserPopQuery | undefined, MenuItemUserPopQueryVariables>;
export function useMenuItemUserPopSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MenuItemUserPopQuery, MenuItemUserPopQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MenuItemUserPopQuery, MenuItemUserPopQueryVariables>(MenuItemUserPopDocument, options);
        }
export type MenuItemUserPopQueryHookResult = ReturnType<typeof useMenuItemUserPopQuery>;
export type MenuItemUserPopLazyQueryHookResult = ReturnType<typeof useMenuItemUserPopLazyQuery>;
export type MenuItemUserPopSuspenseQueryHookResult = ReturnType<typeof useMenuItemUserPopSuspenseQuery>;
export type MenuItemUserPopQueryResult = ApolloReactCommon.QueryResult<MenuItemUserPopQuery, MenuItemUserPopQueryVariables>;